(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('BotNotificationDetailController', BotNotificationDetailController);

    BotNotificationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'BotNotification'];

    function BotNotificationDetailController($scope, $rootScope, $stateParams, previousState, entity, BotNotification) {
        var vm = this;

        vm.botNotification = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:botNotificationUpdate', function(event, result) {
            vm.botNotification = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
